// src/services/authService.js
import api from './api'; // Import the Axios instance

// Login API
export const updateanalysisdataApi = async (payload) => {
  const response = await api.post('users/updateanalysisdata', payload);
  return response.data;
};

export const updateuser = async (payload) => {
  const response = await api.post('users/editList', payload);
  return response.data
}


export const verifyEmail = async (payload) => {
  const response = await api.post('members/verifyEmail', payload);
  return response.data
}



export const sendresetpasswordlink = async (payload) => {
  const response = await api.post('members/sendresetpasswordlink', payload);
  return response.data
}

export const resetpassword = async (payload) => {
  const response = await api.post('members/resetpassword', payload);
  return response.data
}


export const editMember = async (payload) => {
  const response = await api.post('members/editList', payload);
  return response.data;
};

export const getByMemberId = async (payload) => {
  const response = await api.post('members/getById', payload);
  return response.data;
};

export const getMemberAll = async () => {
  const response = await api.get('members/getAll');
  return response.data;
};


export const savelinked = async (payload) => {
  const response = await api.post('members/savelinked', payload);
  return response.data;
};
export const editLinkedList = async (payload) => {
  const response = await api.post('members/editLinkedList', payload);
  return response.data;
};
export const deletelinkedList = async (payload) => {
  const response = await api.post('members/deletelinkedList', payload);
  return response.data;
};
export const getlinkedById = async (payload) => {
  const response = await api.post('members/getlinkedById', payload);
  return response.data;
};
export const getByPrimaryMember = async (payload) => {
  const response = await api.post('members/getByPrimaryMember', payload);
  return response.data;
};
export const getLinkedMemberAll = async () => {
  const response = await api.get('members/getLinkedMemberAll');
  return response.data;
};
export const sendverificationLink = async (payload) => {
  const response = await api.post('members/sendverificationLink', payload);
  return response.data;
};

export const savemembershiptypes = async (payload) => {
  const response = await api.post('members/savemembershiptypes', payload);
  return response.data;
};
export const editmembershiptypes = async (payload) => {
  const response = await api.post('members/editmembershiptypes', payload);
  return response.data;
};
export const getmembershiptype = async (payload) => {
  const response = await api.post('members/getmembershiptype', payload);
  return response.data;
};
export const getallmembershiptypes = async () => {
  const response = await api.get('members/getallmembershiptypes');
  return response.data;
};



export const savemembershippayment = async (payload) => {
  const response = await api.post('members/savemembershippayment', payload);
  return response.data;
};
export const editmembershippayment = async (payload) => {
  const response = await api.post('members/editmembershippayment', payload);
  return response.data;
};
export const getmembershippayment = async (payload) => {
  const response = await api.post('members/getmembershippayment', payload);
  return response.data;
};
export const getallmembershippaymentsbymember = async (payload) => {
  const response = await api.post('members/getallmembershippaymentsbymember',payload);
  return response.data;
};
export const getallmembershippayments = async (payload) => {
  const response = await api.post('members/getallmembershippayments', payload);
  return response.data;
};
export const getallmembershippaymentsbydate = async (payload) => {
  const response = await api.post('members/getallmembershippaymentsbydate', payload);
  return response.data;
};


export const editEvent = async (payload) => {
  const response = await api.post('events/editList', payload);
  return response.data;
};

export const getByEventId = async (payload) => {
  const response = await api.post('events/getById', payload);
  return response.data;
};

export const getEventAll = async () => {
  const response = await api.get('events/getAll');
  return response.data;
};

export const saveEvent = async (payload) => {
  const response = await api.post('events/saveList', payload);
  return response.data;
};

export const saveeventregistration = async (payload) => {
  const response = await api.post('events/saveeventregistration', payload);
  return response.data;
};

export const geteventregistrationById = async (payload) => {
  const response = await api.post('events/geteventregistrationById', payload);
  return response.data;
};

export const getregistrationbyevent = async (payload) => {
  const response = await api.post('events/getregistrationbyevent', payload);
  return response.data;
};

export const getregistrationbydate = async (payload) => {
  const response = await api.post('events/getregistrationbydate', payload);
  return response.data;
};




export const getregistrationbymember = async (payload) => {
  const response = await api.post('events/getregistrationbymember', payload);
  return response.data;
};




export const editregistration = async (payload) => {
  const response = await api.post('events/editregistration', payload);
  return response.data;
};



export const editpackages = async (payload) => {
  const response = await api.post('events/editpackages', payload);
  return response.data;
};

export const savepackage = async (payload) => {
  const response = await api.post('events/savepackage', payload);
  return response.data;
};

export const getpackagebyevent = async (payload) => {
  const response = await api.post('events/getpackagebyevent', payload);
  return response.data;
};

export const getregistrationbymail = async (payload) => {
  const response = await api.post('events/getregistrationbymail', payload);
  return response.data;
};




export const sendcode = async (payload) => {
  const response = await api.post('members/sendcode', payload);
  return response.data;
};



export const saveeventpackagesbulk = async (payload) => {
  try {
    const formattedPayload = {
      payload: payload, // Wrap the payload inside "payload" key
    };

    console.log("Formatted JSON Payload:", JSON.stringify(formattedPayload)); // Debugging

    const response = await api.post(
      "events/savebulk",
      formattedPayload, // Send formatted JSON
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
    
  } catch (error) {
    console.error("Error saving user data:", error);
    throw error;
  }
};

export const uploadmembershippaymentsbulk = async (payload) => {
  try {
    const formattedPayload = {
      payload: payload, // Wrap the payload inside "payload" key
    };

    console.log("Formatted JSON Payload:", JSON.stringify(formattedPayload)); // Debugging

    const response = await api.post(
      "members/savepaymentbulk",
      formattedPayload, // Send formatted JSON
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
    
  } catch (error) {
    console.error("Error saving consumer data:", error);
    throw error;
  }
};

export const create_paypal_order = async (payload) => {
  const response = await api.post('paypal/create_paypal_order', payload);
  return response.data;
};

// export const fetchtransactions = async (payload) => {
//   const response = await api.post('paypal/create_paypal_order', payload);
//   return response.data;
// };

// export const fetchtransactions = async (payload) => {
//   const response = await api.post('paypal/transactions', payload);
//   return response.data;
// };

export const fetchtransactions = async (startDate, endDate) => {
  try {
    const response = await api.get(`paypal/transactions`, {
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Something went wrong");
  }
}


export const uploadsbulk = async (payload) => {
  try {
    const formattedPayload = {
      payload: payload, // Wrap the payload inside "payload" key
    };

    console.log("Formatted JSON Payload:", JSON.stringify(formattedPayload)); // Debugging

    const response = await api.post(
      "members/savebulk",
      formattedPayload, // Send formatted JSON
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
    
  } catch (error) {
    console.error("Error saving consumer data:", error);
    throw error;
  }
};